import React from "react";
import { connect } from "react-redux";
import { Row, Col, Label } from "reactstrap";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import JirangoFontPicker from "../../../../../fonts/FontPicker";
import {
  deepClone,
  setValueToNestedObject,
} from "../../../../../helpers/objectHelper";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { templateHelper } from "../../helpers/templateHelper";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import { FontWeightPicker } from "../../../../../fonts/FontWeightPicker/FontWeightPicker";
import MenuEditDialog from "../../../menu/components/MenuEditDialog";
import Button from "reactstrap/lib/Button";
import { IconButton } from "@material-ui/core";
import BuildIcon from '@material-ui/icons/Build';
class MenuSettings extends React.Component {
  state = {
    activePointer: "normal",
  };
  handleUpdate = (template) => {
    const { dispatch } = this.props;
    dispatch(templateActions.softUpdate(template));
  };
  handleChange = (color, e, path, fallbackUnit = null) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);
    let value = templateHelper.getValueFromInput(e, color);
    let unit = templateHelper.getUnit(templateCopy, names);

    if (!path.includes("active")) {
      if (parseInt(value) && unit.length < 4) {
        value += unit;
      }
      templateCopy.content = deepClone(
        setValueToNestedObject(names, value, templateCopy.content)
      );
    } else {
      templateCopy.content.menu["&:active"][names[2]] = value;
    }
    this.handleUpdate(templateCopy);
  };
  handleUnitChange = (unit, path) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);
    const value = templateHelper.getValueWithoutUnit(templateCopy, names);
    templateCopy.content = setValueToNestedObject(
      names,
      value + unit,
      templateCopy.content
    );

    if (unit === "auto") {
      templateCopy.content[names[0]][names[1]] = unit;
    }
    this.handleUpdate(templateCopy);
  };
  togglePointer = (pointer) => {
    this.setState({ activePointer: pointer });
  };
  render() {
    const { template, device, isMenuModalOpen } = this.props;
    if (template === undefined) return null;
    return (
      <div style={{ paddingTop: "10px" }}>
        {isMenuModalOpen ? <MenuEditDialog /> : null}
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="Display" />
            </Label>
          </Col>
          <Col
            className="list-setting-item-input"
            style={{ textAlign: "right" }}
          >
            <JirangoSwitch
              onChange={() =>
                this.handleChange(
                  null,
                  template.content.menu.display === "none" ||
                    template.content.menu.display === "unset"
                    ? "initial"
                    : "none",
                  "menu.display"
                )
              }
              isChecked={template.content.menu.display === "initial"}
            />
          </Col>
        </Row>

        <React.Fragment>
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="FixedAtTop" />
              </Label>
              <p
                className="text-muted"
                style={{ lineHeight: "initial", marginTop: "0px" }}
              >
                <SystemLabel name="FixedAtTopOnScrollInfo" />
              </p>
            </Col>
            <Col
              className="list-setting-item-input"
              style={{ textAlign: "right" }}
            >
              <JirangoSwitch
                onChange={() =>
                  this.handleChange(
                    null,
                    "menu.position",
                    template.content.menu.position === "unset"
                      ? "fixed"
                      : "unset"
                  )
                }
                isChecked={template.content.menu.position === "fixed"}
              />
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="EditMenu" />
              </Label>
            </Col>
            <Col className="list-setting-item-input text-right">
              <IconButton  onClick={() =>
                  this.props.dispatch(templateActions.toggleMenuModal())
                }>
                <BuildIcon />
              </IconButton>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="TextColor" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <ColorPickerFacade
                color={template ? template.content.menu.color : ""}
                onChange={this.handleChange}
                path="menu.color"
              />
              <br />
            </Col>
          </Row>
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="BackgroundColor" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <ColorPickerFacade
                color={template ? template.content.menu.backgroundColor : ""}
                onChange={this.handleChange}
                path="menu.backgroundColor"
              />

              <br />
            </Col>
          </Row>
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="ActiveTextColor" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <ColorPickerFacade
                color={template ? template.content.menu["&:active"].color : ""}
                onChange={(color, e) =>
                  this.handleChange(color, e, "menu.&:active.color")
                }
                path="menuActive.color"
              />
              <br />
            </Col>
          </Row>
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="ActiveBackgroundColor" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <ColorPickerFacade
                color={
                  template
                    ? template.content.menu["&:active"].backgroundColor
                    : ""
                }
                onChange={(color, e) =>
                  this.handleChange(color, e, "menu.&:active.backgroundColor")
                }
                path="menuActive.backgroundColor"
              />
              <br />
            </Col>
          </Row>
          <hr />

          <JirangoFontPicker
            onChange={this.handleChange}
            path="menu.fontFamily"
            currentFontFamily={template ? template.content.menu.fontFamily : ""}
          />
          <br />
          <FontWeightPicker
            onChange={this.handleChange}
            path="menu.fontWeight"
            currentFont={template.content.text.fontFamily}
            weight={template.content.menu.fontWeight}
          />
          <hr />
          <EditorSlider
            value={templateHelper.getValueWithoutUnit(
              template,
              "menu.fontSize"
            )}
            defaultValue={0}
            unitChange={this.handleUnitChange}
            onChange={this.handleChange}
            units={["px", "em", "rem"]}
            activeUnit={templateHelper.getUnit(template, "menu.fontSize")}
            min={1}
            steps={1}
            max={150}
            path="menu.fontSize"
            label="FontSize"
          />
          <hr />

          <AlignmentButtonGroup
            onChange={this.handleChange}
            alignment={template.content.menu.justifyContent}
            path="menu.justifyContent"
            type={["left", "center", "right"]}
          />
          {/* <Row >
                    <Col className="list-setting-item-title">
                        <Label><SystemLabel name="ItemPlacement" /></Label>
                    </Col>
                    <Col className="list-setting-item-input">
                        <ButtonGroup>
                            <Button
                                color={template.content.menu.justifyContent === "left" ? "primary" : 'secondary'}
                                onClick={e =>
                                    this.setAttribute('left', "menu.justifyContent")
                                }
                            >
                                <i className="fa fa-align-left" />
                            </Button>
                            <Button
                                color={template.content.menu.justifyContent === "center" ? "primary" : 'secondary'}
                                onClick={e =>
                                    this.setAttribute('center', "menu.justifyContent")
                                }
                            >
                                <i className="fa fa-align-center" />
                            </Button>
                            <Button
                                color={template.content.menu.justifyContent === "right" ? "primary" : 'secondary'}
                                onClick={e =>
                                    this.setAttribute('right', "menu.justifyContent")
                                }
                            >
                                <i className="fa fa-align-right" />
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row> */}
          <hr />
          <EditorSlider
            value={templateHelper.getValueWithoutUnit(
              template,
              templateHelper.formatToResponsivePath(
                "menu",
                "innerWidth",
                device
              )
            )}
            responsiveSettings={true}
            defaultValue={0}
            unitChange={this.handleUnitChange}
            onChange={this.handleChange}
            units={["%", "px"]}
            activeUnit={templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath(
                "menu",
                "innerWidth",
                device
              )
            )}
            steps={1}
            max={
              templateHelper.getUnit(
                template,
                templateHelper.formatToResponsivePath(
                  "menu",
                  "innerWidth",
                  device
                )
              ) === "%"
                ? 100
                : 3500
            }
            min={1}
            path={templateHelper.formatToResponsivePath(
              "menu",
              "innerWidth",
              device
            )}
            label="InnerMenuWidth"
          />
          <hr />
          <EditorSlider
            value={templateHelper.getValueWithoutUnit(
              template,
              templateHelper.formatToResponsivePath("menu", "width", device)
            )}
            responsiveSettings={true}
            defaultValue={0}
            unitChange={this.handleUnitChange}
            onChange={this.handleChange}
            units={["%", "px"]}
            activeUnit={templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath("menu", "width", device)
            )}
            steps={1}
            max={
              templateHelper.getUnit(
                template,
                templateHelper.formatToResponsivePath("menu", "width", device)
              ) === "%"
                ? 100
                : 3500
            }
            min={1}
            path={templateHelper.formatToResponsivePath(
              "menu",
              "width",
              device
            )}
            label="MenuWidth"
          />
          <hr />
          <EditorSlider
            value={templateHelper.getValueWithoutUnit(
              template,
              templateHelper.formatToResponsivePath("menu", "padding", device)
            )}
            responsiveSettings={true}
            defaultValue={0}
            unitChange={this.handleUnitChange}
            onChange={this.handleChange}
            units={["%", "px"]}
            activeUnit={templateHelper.getUnit(
              template,
              templateHelper.formatToResponsivePath("menu", "padding", device)
            )}
            steps={1}
            max={
              templateHelper.getUnit(
                template,
                templateHelper.formatToResponsivePath("menu", "padding", device)
              ) === "%"
                ? 100
                : 3500
            }
            min={1}
            path={templateHelper.formatToResponsivePath(
              "menu",
              "padding",
              device
            )}
            label="Padding"
          />
        </React.Fragment>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    alert: state.alert,
    template: state.template.template,
    systemLabels: state.systemLabels,
    device: state.template.previewDevice,
    isMenuModalOpen: state.template.isMenuModalOpen,
  };
}
export default connect(mapStateToProps)(MenuSettings);
